import { defineComponent as t, createBlock as o, openBlock as a, normalizeProps as n, guardReactiveProps as s, unref as c, withCtx as _, renderSlot as f } from "vue";
import { useBindCx as i } from "@scalar/use-hooks/useBindCx";
import l from "./ScalarCardSection.vue.js";
const m = {}, h = /* @__PURE__ */ t({
  ...m,
  inheritAttrs: !1,
  __name: "ScalarCardFooter",
  setup(p) {
    const { cx: r } = i();
    return (e, d) => (a(), o(l, n(s(c(r)("scalar-card-footer"))), {
      default: _(() => [
        f(e.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  h as default
};
